import { CONFIG } from "@/config";
import { UserSubscriptionDomain } from "@/types/UserSubscription";

interface SubscriptionScreenWithPremiumProps {
  currentSubscription: UserSubscriptionDomain | null;
  isRecurrent: boolean;
  cancelRecurrent: () => void;
}

const SubscriptionScreenWithPremium = ({
  currentSubscription,
  isRecurrent,
  cancelRecurrent,
}: SubscriptionScreenWithPremiumProps) => {
  return (
    <div className="flex flex-col items-center justify-between gap-4 h-full">
      <div className="flex flex-col items-center  shadow-md  justify-start gap-10 w-full max-w-md">
        <div className="text-xl font-bold text-white text-center max-w-md">
          Вы уже подписаны
        </div>

        <div className="flex flex-col items-center  shadow-md  justify-center gap-4 w-full max-w-md">
          <div className="text-sm text-white text-center">
            Ваша подписка закончится:{" "}
            {currentSubscription?.endDate?.toLocaleDateString()}
          </div>
          {isRecurrent && (
            <>
              <div className="text-sm text-white text-center">
                Подписка автоматически продлится:{" "}
                {currentSubscription?.endDate?.toLocaleDateString()}
              </div>
              <input
                className="bg-red-500 text-white p-2 rounded-md"
                type="button"
                value="Отменить продление подписки"
                onClick={cancelRecurrent}
              />
            </>
          )}
        </div>
      </div>
      <div
        className="flex flex-col items-center justify-center   z-10"
        style={{ gridRow: "5/7", gridColumn: "1/3" }}
      >
        <div className="text-white text-sm text-center mb-10 ">
          Почта для связи:{" "}
          <a
            href={`mailto:${CONFIG.links.supportEmail}`}
            className="underline text-cyan-300"
          >
            {CONFIG.links.supportEmail}
          </a>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionScreenWithPremium;
